function _(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var $, P;
function U() {
  return P || (P = 1, $ = typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? (...i) => console.error("SEMVER", ...i) : () => {
  }), $;
}
var f, G;
function b() {
  if (G) return f;
  G = 1;
  const n = "2.0.0", i = 256, R = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, a = 16, o = i - 6;
  return f = {
    MAX_LENGTH: i,
    MAX_SAFE_COMPONENT_LENGTH: a,
    MAX_SAFE_BUILD_LENGTH: o,
    MAX_SAFE_INTEGER: R,
    RELEASE_TYPES: [
      "major",
      "premajor",
      "minor",
      "preminor",
      "patch",
      "prepatch",
      "prerelease"
    ],
    SEMVER_SPEC_VERSION: n,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
  }, f;
}
var A = { exports: {} }, C;
function j() {
  return C || (C = 1, function(n, i) {
    const {
      MAX_SAFE_COMPONENT_LENGTH: R,
      MAX_SAFE_BUILD_LENGTH: a,
      MAX_LENGTH: o
    } = b(), l = U();
    i = n.exports = {};
    const N = i.re = [], p = i.safeRe = [], r = i.src = [], e = i.t = {};
    let E = 0;
    const t = "[a-zA-Z0-9-]", I = [
      ["\\s", 1],
      ["\\d", o],
      [t, a]
    ], c = (L) => {
      for (const [h, u] of I)
        L = L.split(`${h}*`).join(`${h}{0,${u}}`).split(`${h}+`).join(`${h}{1,${u}}`);
      return L;
    }, s = (L, h, u) => {
      const X = c(h), O = E++;
      l(L, O, h), e[L] = O, r[O] = h, N[O] = new RegExp(h, u ? "g" : void 0), p[O] = new RegExp(X, u ? "g" : void 0);
    };
    s("NUMERICIDENTIFIER", "0|[1-9]\\d*"), s("NUMERICIDENTIFIERLOOSE", "\\d+"), s("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${t}*`), s("MAINVERSION", `(${r[e.NUMERICIDENTIFIER]})\\.(${r[e.NUMERICIDENTIFIER]})\\.(${r[e.NUMERICIDENTIFIER]})`), s("MAINVERSIONLOOSE", `(${r[e.NUMERICIDENTIFIERLOOSE]})\\.(${r[e.NUMERICIDENTIFIERLOOSE]})\\.(${r[e.NUMERICIDENTIFIERLOOSE]})`), s("PRERELEASEIDENTIFIER", `(?:${r[e.NUMERICIDENTIFIER]}|${r[e.NONNUMERICIDENTIFIER]})`), s("PRERELEASEIDENTIFIERLOOSE", `(?:${r[e.NUMERICIDENTIFIERLOOSE]}|${r[e.NONNUMERICIDENTIFIER]})`), s("PRERELEASE", `(?:-(${r[e.PRERELEASEIDENTIFIER]}(?:\\.${r[e.PRERELEASEIDENTIFIER]})*))`), s("PRERELEASELOOSE", `(?:-?(${r[e.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${r[e.PRERELEASEIDENTIFIERLOOSE]})*))`), s("BUILDIDENTIFIER", `${t}+`), s("BUILD", `(?:\\+(${r[e.BUILDIDENTIFIER]}(?:\\.${r[e.BUILDIDENTIFIER]})*))`), s("FULLPLAIN", `v?${r[e.MAINVERSION]}${r[e.PRERELEASE]}?${r[e.BUILD]}?`), s("FULL", `^${r[e.FULLPLAIN]}$`), s("LOOSEPLAIN", `[v=\\s]*${r[e.MAINVERSIONLOOSE]}${r[e.PRERELEASELOOSE]}?${r[e.BUILD]}?`), s("LOOSE", `^${r[e.LOOSEPLAIN]}$`), s("GTLT", "((?:<|>)?=?)"), s("XRANGEIDENTIFIERLOOSE", `${r[e.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), s("XRANGEIDENTIFIER", `${r[e.NUMERICIDENTIFIER]}|x|X|\\*`), s("XRANGEPLAIN", `[v=\\s]*(${r[e.XRANGEIDENTIFIER]})(?:\\.(${r[e.XRANGEIDENTIFIER]})(?:\\.(${r[e.XRANGEIDENTIFIER]})(?:${r[e.PRERELEASE]})?${r[e.BUILD]}?)?)?`), s("XRANGEPLAINLOOSE", `[v=\\s]*(${r[e.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r[e.XRANGEIDENTIFIERLOOSE]})(?:\\.(${r[e.XRANGEIDENTIFIERLOOSE]})(?:${r[e.PRERELEASELOOSE]})?${r[e.BUILD]}?)?)?`), s("XRANGE", `^${r[e.GTLT]}\\s*${r[e.XRANGEPLAIN]}$`), s("XRANGELOOSE", `^${r[e.GTLT]}\\s*${r[e.XRANGEPLAINLOOSE]}$`), s("COERCEPLAIN", `(^|[^\\d])(\\d{1,${R}})(?:\\.(\\d{1,${R}}))?(?:\\.(\\d{1,${R}}))?`), s("COERCE", `${r[e.COERCEPLAIN]}(?:$|[^\\d])`), s("COERCEFULL", r[e.COERCEPLAIN] + `(?:${r[e.PRERELEASE]})?(?:${r[e.BUILD]})?(?:$|[^\\d])`), s("COERCERTL", r[e.COERCE], !0), s("COERCERTLFULL", r[e.COERCEFULL], !0), s("LONETILDE", "(?:~>?)"), s("TILDETRIM", `(\\s*)${r[e.LONETILDE]}\\s+`, !0), i.tildeTrimReplace = "$1~", s("TILDE", `^${r[e.LONETILDE]}${r[e.XRANGEPLAIN]}$`), s("TILDELOOSE", `^${r[e.LONETILDE]}${r[e.XRANGEPLAINLOOSE]}$`), s("LONECARET", "(?:\\^)"), s("CARETTRIM", `(\\s*)${r[e.LONECARET]}\\s+`, !0), i.caretTrimReplace = "$1^", s("CARET", `^${r[e.LONECARET]}${r[e.XRANGEPLAIN]}$`), s("CARETLOOSE", `^${r[e.LONECARET]}${r[e.XRANGEPLAINLOOSE]}$`), s("COMPARATORLOOSE", `^${r[e.GTLT]}\\s*(${r[e.LOOSEPLAIN]})$|^$`), s("COMPARATOR", `^${r[e.GTLT]}\\s*(${r[e.FULLPLAIN]})$|^$`), s("COMPARATORTRIM", `(\\s*)${r[e.GTLT]}\\s*(${r[e.LOOSEPLAIN]}|${r[e.XRANGEPLAIN]})`, !0), i.comparatorTrimReplace = "$1$2$3", s("HYPHENRANGE", `^\\s*(${r[e.XRANGEPLAIN]})\\s+-\\s+(${r[e.XRANGEPLAIN]})\\s*$`), s("HYPHENRANGELOOSE", `^\\s*(${r[e.XRANGEPLAINLOOSE]})\\s+-\\s+(${r[e.XRANGEPLAINLOOSE]})\\s*$`), s("STAR", "(<|>)?=?\\s*\\*"), s("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), s("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
  }(A, A.exports)), A.exports;
}
var T, F;
function y() {
  if (F) return T;
  F = 1;
  const n = Object.freeze({ loose: !0 }), i = Object.freeze({});
  return T = (a) => a ? typeof a != "object" ? n : a : i, T;
}
var d, g;
function q() {
  if (g) return d;
  g = 1;
  const n = /^[0-9]+$/, i = (a, o) => {
    const l = n.test(a), N = n.test(o);
    return l && N && (a = +a, o = +o), a === o ? 0 : l && !N ? -1 : N && !l ? 1 : a < o ? -1 : 1;
  };
  return d = {
    compareIdentifiers: i,
    rcompareIdentifiers: (a, o) => i(o, a)
  }, d;
}
var m, v;
function H() {
  if (v) return m;
  v = 1;
  const n = U(), { MAX_LENGTH: i, MAX_SAFE_INTEGER: R } = b(), { safeRe: a, t: o } = j(), l = y(), { compareIdentifiers: N } = q();
  class p {
    constructor(e, E) {
      if (E = l(E), e instanceof p) {
        if (e.loose === !!E.loose && e.includePrerelease === !!E.includePrerelease)
          return e;
        e = e.version;
      } else if (typeof e != "string")
        throw new TypeError(`Invalid version. Must be a string. Got type "${typeof e}".`);
      if (e.length > i)
        throw new TypeError(
          `version is longer than ${i} characters`
        );
      n("SemVer", e, E), this.options = E, this.loose = !!E.loose, this.includePrerelease = !!E.includePrerelease;
      const t = e.trim().match(E.loose ? a[o.LOOSE] : a[o.FULL]);
      if (!t)
        throw new TypeError(`Invalid Version: ${e}`);
      if (this.raw = e, this.major = +t[1], this.minor = +t[2], this.patch = +t[3], this.major > R || this.major < 0)
        throw new TypeError("Invalid major version");
      if (this.minor > R || this.minor < 0)
        throw new TypeError("Invalid minor version");
      if (this.patch > R || this.patch < 0)
        throw new TypeError("Invalid patch version");
      t[4] ? this.prerelease = t[4].split(".").map((I) => {
        if (/^[0-9]+$/.test(I)) {
          const c = +I;
          if (c >= 0 && c < R)
            return c;
        }
        return I;
      }) : this.prerelease = [], this.build = t[5] ? t[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(e) {
      if (n("SemVer.compare", this.version, this.options, e), !(e instanceof p)) {
        if (typeof e == "string" && e === this.version)
          return 0;
        e = new p(e, this.options);
      }
      return e.version === this.version ? 0 : this.compareMain(e) || this.comparePre(e);
    }
    compareMain(e) {
      return e instanceof p || (e = new p(e, this.options)), N(this.major, e.major) || N(this.minor, e.minor) || N(this.patch, e.patch);
    }
    comparePre(e) {
      if (e instanceof p || (e = new p(e, this.options)), this.prerelease.length && !e.prerelease.length)
        return -1;
      if (!this.prerelease.length && e.prerelease.length)
        return 1;
      if (!this.prerelease.length && !e.prerelease.length)
        return 0;
      let E = 0;
      do {
        const t = this.prerelease[E], I = e.prerelease[E];
        if (n("prerelease compare", E, t, I), t === void 0 && I === void 0)
          return 0;
        if (I === void 0)
          return 1;
        if (t === void 0)
          return -1;
        if (t === I)
          continue;
        return N(t, I);
      } while (++E);
    }
    compareBuild(e) {
      e instanceof p || (e = new p(e, this.options));
      let E = 0;
      do {
        const t = this.build[E], I = e.build[E];
        if (n("build compare", E, t, I), t === void 0 && I === void 0)
          return 0;
        if (I === void 0)
          return 1;
        if (t === void 0)
          return -1;
        if (t === I)
          continue;
        return N(t, I);
      } while (++E);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(e, E, t) {
      switch (e) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", E, t);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", E, t);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", E, t), this.inc("pre", E, t);
          break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", E, t), this.inc("pre", E, t);
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        // This probably shouldn't be used publicly.
        // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
        case "pre": {
          const I = Number(t) ? 1 : 0;
          if (!E && t === !1)
            throw new Error("invalid increment argument: identifier is empty");
          if (this.prerelease.length === 0)
            this.prerelease = [I];
          else {
            let c = this.prerelease.length;
            for (; --c >= 0; )
              typeof this.prerelease[c] == "number" && (this.prerelease[c]++, c = -2);
            if (c === -1) {
              if (E === this.prerelease.join(".") && t === !1)
                throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(I);
            }
          }
          if (E) {
            let c = [E, I];
            t === !1 && (c = [E]), N(this.prerelease[0], E) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = c) : this.prerelease = c;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${e}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  }
  return m = p, m;
}
var S, w;
function k() {
  if (w) return S;
  w = 1;
  const n = H();
  return S = (R, a, o = !1) => {
    if (R instanceof n)
      return R;
    try {
      return new n(R, a);
    } catch (l) {
      if (!o)
        return null;
      throw l;
    }
  }, S;
}
var D, M;
function V() {
  if (M) return D;
  M = 1;
  const n = k();
  return D = (R, a) => {
    const o = n(R, a);
    return o ? o.version : null;
  }, D;
}
var B = V();
const x = /* @__PURE__ */ _(B), z = () => {
  var i;
  if (!window.navigator.userAgent.includes("IGApp"))
    return;
  const n = window.navigator.userAgent.includes("IGApp/") ? (i = window.navigator.userAgent.split("IGApp/")[1]) == null ? void 0 : i.split(" ")[0] : void 0;
  if (n && x(n))
    return n;
};
function Y(n) {
  var i;
  "IGWebViewBridge" in window && ((i = window.IGWebViewBridge) == null || i.sendEvent(n));
}
const W = z();
export {
  W as appVersion,
  Y as dispatchMobileAppEvent
};
